import React, { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import styled from "styled-components";
import PropTypes from "prop-types";

import { getConfig } from "../../utils/config"

const config = getConfig();

const hideGoogleRecaptcha = config.features.hideGoogleRecaptcha

const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  scale: 0.8;
  margin-top: 20px;
  margin-bottom: 20px;
`;

/**
 * Google reCAPTCHA wrapper component.
 * 
 * the reCAPTCHA widget remains hidden and automatically triggers
 * `onChange(true)`. Otherwise, it displays the widget and calls
 * `onChange` with the verification result.
 *
 * @param {Object} props
 * @param {Function} [props.onChange] - Callback fired when:
 *  - reCAPTCHA is successfully validated (receives the token).
 *  - reCAPTCHA expires or errors out (receives `false`).
 *
 * @example
 * <CaptchaCheck onChange={(value) => console.log("Captcha status:", value)} />
 */
function CaptchaCheck({ onChange }) {
  const isHidden = hideGoogleRecaptcha;

  useEffect(() => {
    if (isHidden && onChange) {
      onChange(true);
    }
  }, [isHidden, onChange]);

  const handleChange = (value) => onChange ? onChange(!!value) : null;
  const handleExpire = () => onChange ? onChange(false) : null;

  return hideGoogleRecaptcha ? null : (
    <CenteredDiv>
      <ReCAPTCHA
        sitekey="6LdfmIUlAAAAAJUK2xhCmFq0YwpvelFOLAXSFuHw"
        onChange={handleChange}
        onExpired={handleExpire}
        onErrored={handleExpire}
      />
    </CenteredDiv>
  );
}

CaptchaCheck.propTypes = {
  onChange: PropTypes.func,
};

export default CaptchaCheck;



// WEBPACK FOOTER //
// ./src/_components/GoogleReCAPTCHA/index.js